import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  createBlob as createBlobAction
} from 'actions/blobs';
import useError from './useError';

const useBlob = () => {
  const { setError } = useError();
  const dispatch = useDispatch();
  const createBlob = useCallback(blob => dispatch(createBlobAction(blob)), [dispatch]);

  const processBlob = ({ file, checksum, type }, callback = null) => {
    const blob = { name: file.name, size: file.size, type: file.type, checksum, file };

    return createBlob(blob)
      .then(({ payload: { data: { blob: { id, url, content_type, filename } } } }) => {
        const result = { id, url, content_type, filename };
        if (callback) callback(result);
        return result;
      })
      .catch((error) => {
        setError(error);
        return Promise.reject(error);
      });
  };

  return { processBlob };
};

export default useBlob;